import React, { FC, useState, useEffect } from 'react'
import { IonModal, IonContent } from '@ionic/react'
import { cartMobx, discountMobx } from '@mobx/mall'
import ProductsItem from './productsItem'
import { observer } from 'mobx-react'
import { ModalHeader } from '@cps'
import { get, isEmpty } from '@dt/fe-utils/dist/lodash'

interface IProps {
  reject?: any;
  resolve?: any;
  data: any;
}

const SingleCouponsModal: FC<IProps> = ({ data, reject = () => { }, resolve = () => {} }) => {
  const currentSelectPK = get(discountMobx.discountAction.selectItemCouponMap, `${data?.memberCouponId}`)
  const [cache, setCache] = useState({})
  useEffect(() => {
    if (data?.memberCouponId && data?.canUseProductPk?.filter(pk => pk === currentSelectPK)?.length) {
      setCache(Object.entries(discountMobx.discountAction.selectItemCouponMap)
        .filter(([, pk]) => pk === currentSelectPK && discountMobx.discountResult.memberItemCouponMap[data?.memberCouponId].couponId === data.couponId)
        .map(([key]) => key)
        .reduce((t, c, idx) => ({ ...t, [c]: idx + 1 }), {}))
    } else {
      setCache({})
    }
  }, [data?.memberCouponId])
  const index = data?.memberCouponId && get(cache, data?.memberCouponId)
  const cartItems: Array<IViewMallCartItem|IViewOrderDetail> = isEmpty(cartMobx.viewCartItems) ? cartMobx.viewOrderItems : cartMobx.viewCartItems
  return (
    <IonModal
      isOpen
      cssClass='mall-coupon-modal tall-modal'
      onDidPresent={() => {
        (document.getElementById('couponSlider') as any)?.update?.()
      }}
    >
      <ModalHeader title={i18n.t('cart.chooseCouponProduct')} onClose={reject} />
      <IonContent scrollX={false} scrollY={false}>
        <div className='mall-product-content-box'>
          <div className='product-sliders product-list'>
            {(data?.canUseProductPk || []).map((pk, idx) => {
              const item: IViewCartItem | IViewOrderDetail = (cartItems.find(i => i.pk === pk) as IViewCartItem | IViewOrderDetail)
              const key = `${item.pk}_${idx}`
              const pIdx = data?.canUseProductPk.findIndex(cpk => cpk === pk)
              return (
                <div key={key}>
                  <ProductsItem
                    product={item}
                    memberCouponId={data.memberCouponId}
                    isSelect={currentSelectPK === item.pk && (index ? index === (idx - pIdx) + 1 : true)}
                    onUseClick={(coupon) => {
                      discountMobx.selectSingleProductCoupon(discountMobx.discountAction.selectItemCouponMap[coupon.memberCouponId] === coupon?.pk ? (`${coupon?.memberCouponId}`) : { ...discountMobx.discountAction.selectItemCouponMap, [coupon?.memberCouponId as number]: coupon?.pk })
                      // discountMobx.selectSingleProductCoupon(discountMobx.discountAction.selectItemCouponMap[coupon.memberCouponId] === coupon?.pk ? (`${coupon?.memberCouponId}`) : {
                      //   [coupon.memberCouponId]: coupon.pk
                      // }, coupon.status === 'mutex')
                      resolve()
                    }}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(SingleCouponsModal)
